import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

import ColumnedSection from '../right-pane/columned-section';
import ExpansionComponent from '../right-pane/expansion-component';
import SenderDetailsNotesContainer from './sender-details-notes-container';

import { formatNumber, formatRate } from '../utils/common-utils';

const styles = theme => ( {
    verified: {
        marginTop: -8,
    }
} );

const SenderDetailsTabGeneral = ( { classes, senderData } ) => {
    const {
        authorizedMailVolume,
        dmarcPassRate,
        blockRate,
        dmarcDoublePassRate,
        spfPassRate,
        dkimPassRate,
        spfPassAlignRate,
        spfAlignRate,
        dkimAlignRate,
        dkimPassAlignRate,
        unauthorizedBlockRate,
        unauthorizedDMARCPassRate,
        unauthorizedMailVolume
    } = senderData;

    const senderInfo = [
        { automationId: 'sender-details-general-auth-volume', title: 'Message Volume', value: formatNumber( authorizedMailVolume ) },
        { automationId: 'sender-details-general-auth-dmarc-pass', title: 'DMARC Pass Rate', value: formatRate( dmarcPassRate ) },
        { automationId: 'sender-details-general-auth-spf-pass', title: '(SPF) DMARC Pass Rate', value: formatRate( spfPassAlignRate ) },
        { automationId: 'sender-details-general-auth-spf-pass', title: '(DKIM) DMARC Pass Rate', value: formatRate( dkimPassAlignRate ) },
        { automationId: 'sender-details-general-auth-dmarc-doube-pass', title: 'DMARC Double Pass Rate', value: formatRate( dmarcDoublePassRate ) },
        { automationId: 'sender-details-general-auth-spf-pass', title: 'SPF Pass Rate', value: formatRate( spfPassRate ) },
        { automationId: 'sender-details-general-auth-dkim-pass-rate', title: 'DKIM Pass Rate', value: formatRate( dkimPassRate ) },
        { automationId: 'sender-details-general-auth-spf-align', title: 'SPF Alignment Rate', value: formatRate( spfAlignRate ) },
        { automationId: 'sender-details-general-auth-dkim-align', title: 'DKIM Alignment Rate', value: formatRate( dkimAlignRate ) },
        { automationId: 'sender-details-general-auth-blocked', title: 'Block Rate', value: formatRate( blockRate ) },
    ];

    const unverifiedSenderInfo = [
        { automationId: 'sender-details-general-unauth-volume', title: 'Message Volume', value: formatNumber( unauthorizedMailVolume ) },
        { automationId: 'sender-details-general-unauth-dmarc-pass', title: 'DMARC Pass Rate', value: formatRate( unauthorizedDMARCPassRate ) },
        { automationId: 'sender-details-general-unauth-blocked', title: 'Block Rate', value: formatRate( unauthorizedBlockRate ) },
    ];

    return (
        <>
        <div className={classes.verified}>
            <ExpansionComponent
                title="Messages (permitted domains)"
                dataAutomationId="sender-details-verified-messages-section"
                expanded
                noDivider
            >
                <ColumnedSection data={senderInfo} expandable={true} />
            </ExpansionComponent>
            <ExpansionComponent
                title="Messages (not permitted & undetermined domains)"
                dataAutomationId="sender-details-unverified-messages-section"
                expanded
            >
                <ColumnedSection data={unverifiedSenderInfo} expandable={true} />
            </ExpansionComponent>
        </div>
        <ExpansionComponent title="Notes" dataAutomationId="sender-details-general-notes-section">
            <SenderDetailsNotesContainer senderNotesData={[]}/>
        </ExpansionComponent>
        </>
    );
};

SenderDetailsTabGeneral.propTypes = {
    classes: PropTypes.object,
    senderData: PropTypes.object,
};

export default withStyles( styles )( SenderDetailsTabGeneral );
